import once from 'lodash/once';

const partialCollapse = {
  initCollapse: once(() => {
    var timeout;
    window.addEventListener(
      'resize',
      function() {
        if (!timeout) {
          timeout = setTimeout(function() {
            timeout = null;
            partialCollapse.initContainer();
          }, 500);
        }
      },
      false,
    );

    partialCollapse.initContainer();
  }),
  /**
   * Init container data
   */

  initContainer: () => {
    document.querySelectorAll('.generic-partial-collapse-container').forEach(container => {
      //calculate viewable element height by fetching its top and bottom position from top of the page
      let parentDistanceFromTop = container.offsetTop;
      let desiredChildNode = container.dataset.showDefault - 1; // index starts at 0

      //TODO: This should be more generic classname because functionality can be used outside of car-page accessories context.
      const accessoryElements = container.querySelectorAll('.accessory');
      let child = accessoryElements.item(desiredChildNode);

      //If there is less than five accessories in the partial collapse element then hide toggle button.
      const showAmount = container.dataset.showDefault || 5;

      if( accessoryElements.length <= showAmount ) {
        const togglePartialElement = container.parentElement.querySelector('.toggle-partial');
        togglePartialElement.classList.add('hide');
      }

      if (child) {
        let childDistanceFromTop = child.offsetTop;
        let childHeight = child.scrollHeight;
        let defaultHeight = (childDistanceFromTop + childHeight) - parentDistanceFromTop;

        if (container.classList.contains('open')) {
          container.style.maxHeight = partialCollapse.countMaxHeight(container) + 'px';
        } else {
          container.style.maxHeight = defaultHeight + 'px';
        }

        container.setAttribute('data-height', defaultHeight);
      }
    });

    document.querySelectorAll('.toggle-partial').forEach(container => {
      container.addEventListener('click', partialCollapse.initToggle);
    });

  },
  /**
   * Init triggers
   * @param {event} e events
   */
  initToggle: e => {
    const parentContainer = e.target.closest('.partial-collapse-wrapper');
    const child = parentContainer.querySelector('.generic-partial-collapse-container');
    child.classList.toggle('open');

    let caretIcon = e.target.querySelector('.caret');
    let toggleButton = parentContainer.querySelector('.generic-clickable');
    let maxHeight = partialCollapse.countMaxHeight(child);

    // set open and closed data (text + height)
    if (child.classList.contains('open')) {
      parentContainer.querySelector('.generic-clickable').childNodes[0].textContent = toggleButton.getAttribute('data-closed');
      child.style.maxHeight = maxHeight + 'px';
      caretIcon.classList.remove('caret-down');
      caretIcon.classList.add('caret-up');
    } else {
      parentContainer.querySelector('.generic-clickable').childNodes[0].textContent = toggleButton.getAttribute('data-open');
      child.style.maxHeight = child.getAttribute('data-height') + 'px';
      caretIcon.classList.remove('caret-up');
      caretIcon.classList.add('caret-down');
    }
  },
  /**
   * Count container height
   * @param {object} container object
   * @returns {int} counted height
   */
  countMaxHeight: (container) => {
    let children = container.children;
    let maxHeight = 0;

    for (let i = 0; i < children.length; i++) {
      maxHeight = (maxHeight + children[i].offsetHeight);
    }
    return maxHeight;
  }
}

export default partialCollapse;
